class CollectionPagination extends HTMLElement {
    constructor() {
        super();
        this.currentPage = parseInt(this.dataset.current);
        this.totalPages = parseInt(this.dataset.total);
        this.collection = this.dataset.collection;
        this.sectionId = this.dataset.sectionId;
        this.productGrid = document.getElementById('product-grid');
        this.isLoading = false;
    }
    
    connectedCallback() {
        this.render();
        this.bindEvents();
    }
    
    render() {
        this.renderNumbers();
        this.updateButtons();
    }
    
    renderNumbers() {
        const numbersContainer = this.querySelector('.pagination-numbers');
        const range = this.getPageRange();
        
        numbersContainer.innerHTML = range.map(page => 
            `<button data-page="${page}" class="pagination-number w-[46px] h-[46px] flex items-center justify-center transition-all font-heading text-[16px] leading-[100%] font-bold ${page === this.currentPage ? ' opacity-100 ' : ' opacity-20 '}">${page}</button>`
        ).join('');
    }
    
    updateButtons() {
        const prevBtn = this.querySelector('.pagination-prev');
        const nextBtn = this.querySelector('.pagination-next');
        
        prevBtn.disabled = this.currentPage === 1;
        nextBtn.disabled = this.currentPage === this.totalPages;
    }
    
    getPageRange() {
        let start, end;
        
        if (this.currentPage <= 2) {
            start = 1;
            end = Math.min(3, this.totalPages);
        } else if (this.currentPage >= this.totalPages - 1) {
            start = Math.max(this.totalPages - 2, 1);
            end = this.totalPages;
        } else {
            start = this.currentPage - 1;
            end = this.currentPage + 1;
        }
        
        return Array.from({length: end - start + 1}, (_, i) => start + i);
    }
    
    async loadPage(page) {
        if (this.isLoading || page === this.currentPage) return;
        
        this.isLoading = true;
        this.showLoading();
        
        try {
            // Build URL with current search params but new page
            const url = new URL(window.location);
            const searchParams = new URLSearchParams(url.search);
            
            if (page === 1) {
                searchParams.delete('page');
            } else {
                searchParams.set('page', page);
            }
            
            // Create fetch URL without changing current URL
            const fetchUrl = `/collections/${this.collection}${searchParams.toString() ? '?' + searchParams.toString() : ''}`;
            
            const response = await fetch(fetchUrl, {
                headers: {
                    'X-Requested-With': 'XMLHttpRequest'
                }
            });
            
            if (!response.ok) throw new Error('Network response was not ok');
            
            const html = await response.text();
            this.updateProducts(html, page);
            
        } catch (error) {
            console.error('Error loading page:', error);
            // Fallback to regular navigation
            window.location.href = `/collections/${this.collection}${page > 1 ? '?page=' + page : ''}`;
        } finally {
            this.isLoading = false;
            this.hideLoading();
        }
    }
    
    updateProducts(html, newPage) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        
        const newGrid = doc.querySelector('#product-grid');
        if (!newGrid) {
            throw new Error('Product grid not found in response');
        }
        
        this.productGrid.style.opacity = '0';
        
        setTimeout(() => {
            this.productGrid.innerHTML = newGrid.innerHTML;
            this.productGrid.style.opacity = '1';
            
            // Update pagination state
            this.currentPage = newPage;
            this.render();
            this.scrollToGrid();
        }, 150);
    }
    
    showLoading() {
        const loader = this.querySelector('.pagination-loading');
        loader?.classList.remove('hidden');
    }
    
    hideLoading() {
        const loader = this.querySelector('.pagination-loading');
        loader?.classList.add('hidden');
    }
    
    scrollToGrid() {
        const container = document.querySelector('.collection-container-template');
        container?.scrollIntoView({behavior: 'smooth', block: 'start'});
    }
    
    bindEvents() {
        const prevBtn = this.querySelector('.pagination-prev');
        const nextBtn = this.querySelector('.pagination-next');
        
        prevBtn.onclick = () => {
            if (this.currentPage > 1) {
                this.loadPage(this.currentPage - 1);
            }
        };
        
        nextBtn.onclick = () => {
            if (this.currentPage < this.totalPages) {
                this.loadPage(this.currentPage + 1);
            }
        };
        
        this.addEventListener('click', (e) => {
            if (e.target.matches('.pagination-number')) {
                const page = parseInt(e.target.dataset.page);
                this.loadPage(page);
            }
        });
    }
}

customElements.define('collection-pagination', CollectionPagination);